import React from 'react';

import { Tenant } from '@/types/common';
import { Option } from '@/types/components/common';

import { isCaymanTenant } from '@/utils/tenant';

import CaymanAddressFields from './CaymanAddressFields';
import DefaultAddressFields from './DefaultAddressFields';

export type AddressFieldsProps = {
  isPending: boolean;
  popularCountryOptions: Option[];
  tenant?: Tenant;
};

const AddressFields = ({
  isPending,
  popularCountryOptions,
  tenant,
}: AddressFieldsProps) => {
  if (isCaymanTenant(tenant)) {
    return (
      <CaymanAddressFields
        isPending={isPending}
        popularCountryOptions={popularCountryOptions}
      />
    );
  }

  return (
    <DefaultAddressFields
      isPending={isPending}
      popularCountryOptions={popularCountryOptions}
    />
  );
};

export default React.memo(AddressFields);
